export const GOALS_MAP = {};
